/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
/* eslint-enable import/no-extraneous-dependencies */
import MayurProfile from '../../../assets/mayur-profile.png';
import MadhurProfile from '../../../assets/madhur-profile.png';


import styles from '../card.module.css';
import aboutStyles from './about.module.css';

export default () => (
  <div className={aboutStyles.aboutContainer}>
    <div className={aboutStyles.detailsContainer}>
      <div className={aboutStyles.profilePic}>
        <img src={MadhurProfile} alt="Madhur's Profile" />
      </div>
      <div className={aboutStyles.content}>
        <h3>"When brothers agree, no fortress is as strong as their common life."</h3>
        <h4>~Antisthenes</h4>
      </div>
      <div className={`${aboutStyles.profilePic} ${aboutStyles.altProfile}`}>
        <img src={MayurProfile} alt="Mayur's Profile" />
      </div>
    </div>


  </div>
);



// WEBPACK FOOTER //
// ./src/pageComponents/about/index.jsx